import EngagementsDemoPage from 'app/PoC/DataGridDemoPages/EngagementsDemo/EngagementsDemoPage'
import {
    createSkyNetObjectRoutes,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.utils'

import domainConfig from './EngagementsDemo.config'

export default createSkyNetObjectRoutes(<EngagementsDemoPage />, domainConfig)
